module.exports = __webpack_public_path__ + "img/default-avatar.8e52b8c8.png";